import React from 'react'
import styled from 'styled-components'
import { colors, breakpoints } from '../utils/utils'

export default props => {
    return (
        <Nav>
            <ul>
                {props.links}
            </ul>
        </Nav>
    )
}

const Nav = styled.nav`
  ${breakpoints.md}{
    display:none;
  }
  ul {
    display : flex;
    padding: 0;

    a {
      display: block;
      text-decoration : none;
      color : ${colors.tertiary};
      padding: .2rem 1rem;
      ${breakpoints.lg} {
          padding: 0 .5rem;
          font-size: .9375rem;
      }
    }
  }

  .submenu {
    position: relative;
    &:hover .submenu-block {
        display: block;
        position: absolute;
        top: 100%;
        left: 0;
    } 
    
    .submenu-block {
        display: none;
        width: 100%;
        text-align: center;
        border: 1px solid ${colors.tertiary};
        background-color: ${colors.secondary};
        line-height: initial;
        
        a {
            display: block;
            height: 100%;
            &:hover {
                background-color: ${colors.primary};
            }
            &:not(:first-child) {
                border-top: 1px solid ${colors.tertiary};
            }
        }
    }
  }
`
